export default "__VITE_ASSET__DhcEFeAD__"